import React from "react";
import { ShieldCheck, BookOpen, Handshake } from "lucide-react";

const VALUES = [
  {
    icon: ShieldCheck,
    title: "Integritas",
    text: "Setiap akta dibuat dengan ketelitian, kerahasiaan, dan kepatuhan penuh pada peraturan perundang-undangan.",
  },
  {
    icon: BookOpen,
    title: "Edukatif",
    text: "Kami menjelaskan setiap pasal dan implikasi hukum dalam bahasa yang mudah dipahami klien.",
  },
  {
    icon: Handshake,
    title: "Personal",
    text: "Pendekatan boutique — Anda berbicara langsung dengan notaris, bukan dilempar dari meja ke meja.",
  },
];

export const About = () => {
  return (
    <section
      id="tentang"
      data-testid="about-section"
      className="py-24 lg:py-32 bg-[#F0EFEA] hp-grain"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="hp-divider" />
              <span className="overline">Tentang</span>
            </div>
            <h2 className="font-serif text-4xl lg:text-5xl xl:text-6xl text-[#1A2B29] tracking-tight font-light leading-[1.05]">
              Membantu Anda <em className="italic text-[#C4A661]">melangkah pasti</em> di setiap
              keputusan hukum.
            </h2>

            <figure className="mt-10 relative aspect-[4/5] max-w-md overflow-hidden border border-[#E5E3DC]">
              <img
                src="/assets/helen-pelantikan.png"
                alt="Helen Parlista pada Pelantikan dan Pembekalan Notaris Provinsi Jawa Barat 2025"
                className="w-full h-full object-cover object-top"
              />
              <figcaption className="absolute left-0 right-0 bottom-0 bg-gradient-to-t from-[#1A2B29]/90 to-transparent text-[#F9F8F6] p-5">
                <div className="text-[10px] uppercase tracking-[0.22em] text-[#C4A661] mb-1">
                  Pelantikan Resmi
                </div>
                <div className="font-serif italic text-base leading-snug">
                  Pelantikan & Pembekalan Notaris
                  <br />
                  Provinsi Jawa Barat — Bandung, 2025
                </div>
              </figcaption>
            </figure>
          </div>

          <div className="lg:col-span-7">
            <p className="text-lg text-[#1A2B29] leading-relaxed font-light">
              <span className="font-serif text-2xl text-[#1A2B29]">Helen Parlista, S.H, M.Kn</span>{" "}
              adalah Notaris dan PPAT yang dilantik resmi oleh Kementerian Hukum R.I. — Kantor
              Wilayah Jawa Barat tahun 2025. Berkedudukan di Indramayu, Helen melayani klien
              individu, keluarga, dan badan usaha dengan pendekatan teliti dan komunikatif.
            </p>
            <p className="mt-6 text-base text-[#5C6B69] leading-relaxed">
              Kami melayani konsultasi tatap muka di kantor maupun daring. Setiap kasus ditangani
              langsung oleh Helen, didampingi tim asisten yang berpengalaman. Kerahasiaan klien
              kami jaga sesuai kewajiban jabatan notaris.
            </p>

            <div className="mt-12 grid sm:grid-cols-3 gap-6">
              {VALUES.map((v, i) => {
                const Icon = v.icon;
                return (
                  <div
                    key={i}
                    data-testid={`value-card-${i}`}
                    className="hp-card p-6"
                  >
                    <Icon size={28} strokeWidth={1.2} className="text-[#C4A661] mb-4" />
                    <h3 className="font-serif text-xl text-[#1A2B29] mb-2">{v.title}</h3>
                    <p className="text-sm text-[#5C6B69] leading-relaxed">{v.text}</p>
                  </div>
                );
              })}
            </div>

            <div className="mt-12 border-t border-[#E5E3DC] pt-8">
              <div className="grid sm:grid-cols-2 gap-6">
                <div>
                  <div className="overline mb-2">Pendidikan</div>
                  <div className="font-serif text-lg text-[#1A2B29]">
                    Magister Kenotariatan (M.Kn)
                  </div>
                  <div className="text-sm text-[#5C6B69]">Sarjana Hukum (S.H)</div>
                </div>
                <div>
                  <div className="overline mb-2">Pelantikan & Wilayah</div>
                  <div className="font-serif text-lg text-[#1A2B29]">
                    Notaris &amp; PPAT — Jawa Barat
                  </div>
                  <div className="text-sm text-[#5C6B69]">
                    Dilantik Kemenkumham RI Kanwil Jabar, 2025
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
